export default "__VITE_ASSET__Crd5Aa7I__"